import React, { useEffect, useState } from 'react';
import { AirportShuttleOutlined } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { TransportationListItem } from '~/components/carePlan/TransportationList/TransportationListItem';
import { AddTransportationModal } from '~/components/carePlan/TransportationList/AddTransportationModal';
import { useQueryClient } from 'react-query';
export const TransportationListBox = (props) => {
    const [listItems, setListItems] = useState(props.transportationList);
    const [itemToEdit, setItemToEdit] = useState(undefined);
    const [showAddModal, setShowAddModal] = useState(false);
    const queryClient = useQueryClient();
    useEffect(() => {
        setListItems(props.transportationList);
    }, [props.transportationList]);
    // Calculate the most recent update date
    const getLatestUpdateDate = () => {
        if (listItems.length === 0) {
            return '';
        }
        const latestDate = listItems.reduce((latest, item) => {
            const itemLatest = item.updatedAt > item.createdAt
                ? item.updatedAt
                : item.createdAt;
            return itemLatest > latest ? itemLatest : latest;
        }, new Date(0));
        return latestDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const handleEdit = (id) => {
        setItemToEdit(listItems.find(obj => obj.id === id));
        setShowAddModal(true);
    };
    const handleDelete = (id) => {
        setListItems(prev => prev.filter(item => item.id !== id));
        queryClient.invalidateQueries(['getPatientTimeline', props.patientId]);
    };
    const onAddEntry = () => {
        setItemToEdit(undefined);
        setShowAddModal(true);
    };
    const handleProblemSuccess = (updatedItem) => {
        if (itemToEdit) {
            // Edit: Update existing problem in the list
            setListItems(prev => prev.map(item => item.id === updatedItem.id ? updatedItem : item));
        }
        else {
            // Add: Append new problem to the list
            setListItems(prev => [...prev, updatedItem]);
        }
        setShowAddModal(false);
        queryClient.invalidateQueries(['getPatientTimeline', props.patientId]);
    };
    return (React.createElement("div", { style: { width: '100%', height: '100%', background: 'white', borderRadius: 6, outline: '1px var(--elevation-outlined, #E0E0E0) solid', outlineOffset: '-1px', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: 7, display: 'inline-flex' } },
        showAddModal &&
            React.createElement(AddTransportationModal, { onRequestClose: () => setShowAddModal(false), itemToEdit: itemToEdit ? itemToEdit : null, patientId: props.patientId, onSuccess: handleProblemSuccess, presets: props.presets }),
        React.createElement("div", { style: { padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' } },
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                React.createElement(AirportShuttleOutlined, { style: { color: '#0000008A', height: '20px', width: '20px' } }),
                React.createElement("span", { style: { fontSize: 14, color: '#000000DE', fontFamily: 'Barlow', fontWeight: '600', } }, "Transportation")),
            React.createElement("div", { style: { fontSize: 12, color: '#00000099', fontFamily: 'Barlow', fontWeight: '500' } },
                listItems.length > 0 && 'Updated: ',
                " ",
                getLatestUpdateDate())),
        React.createElement("div", { style: { paddingLeft: '16px' } },
            React.createElement(Button, { variant: "outlined", disabled: props.isAddDisabled, onClick: onAddEntry, style: { textTransform: 'none', borderRadius: '20px', height: '30px' } }, "Add Entry")),
        React.createElement("div", { style: {
                flex: 1,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
            }, className: "problem-list-scroll" }, listItems.map((item) => (React.createElement(TransportationListItem, { key: item.id, item: item, onEdit: handleEdit, onDelete: handleDelete, isEditDisabled: props.isAddDisabled }))))));
};
